import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsIceSkateNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M.5 13.409A2.093 2.093 0 002.591 15.5h10.991a1.918 1.918 0 001.366-3.265l-.748-.765a1.507 1.507 0 001.25-1.48V8.82a1.5 1.5 0 00-1.05-1.44l-2.24-.71-4.09-2.2-.5-2.97a1.2 1.2 0 00-1.18-1H5.5a1.192 1.192 0 00-1.13.82L3.64 3.5H2.37l.4-2H1.75L.84 6A16.9 16.9 0 00.5 9.4a2.089 2.089 0 00.948 1.748L.76 12.4c-.17.31-.26.656-.26 1.009zM5.32 1.63a.183.183 0 01.18-.13h.89a.193.193 0 01.19.17l.31 1.83h-2.2l.63-1.87zM1.58 7.79l3.2 1.71h2.11L1.73 6.73c.02-.178.05-.355.09-.53l.34-1.7h4.9l.03.17-.79 1.47.88.47.62-1.15 1.44.77-.62 1.16.88.47.63-1.16 1.43.77-.62 1.17.88.47.69-1.29 1.58.51a.513.513 0 01.36.49v1.17a.512.512 0 01-.51.51H2.6a1.1 1.1 0 01-1.1-1.1c0-.54.03-1.07.08-1.61zm8.92 3.71v.5a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5v-.5h5zm-8.864 1.383L2.4 11.49c.1.017.139.01 2.1.01v.5A1.5 1.5 0 006 13.5h4a1.5 1.5 0 001.5-1.5v-.5h1.319l1.417 1.437a.92.92 0 01-.654 1.563H2.591a1.09 1.09 0 01-.955-1.617z"
        fill=""
      />
    </svg>
  )
);
SvgSportsIceSkateNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsIceSkateNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsIceSkateNormalXsmall;
